import { useContext } from "react";
import { SCHOOLS_PATH } from "../../functions/src/admin/paths";
import type { Lang, Schools } from "../types";
import { useDatabase } from "./firebaseHooks";
import { getLangValue, langContext, type Language } from "./Lang";

/**
 * Resolved school title for the active UI language (`schoolName` is {@link Lang}).
 * Falls back to `schoolKeyFallback` when the name is missing or empty in both languages.
 */
export function getSchoolDisplayName(
    school: { schoolName?: Lang } | null | undefined,
    schoolKeyFallback: string,
    lang: Language
): string {
    const label = getLangValue(school?.schoolName, lang);
    return label || schoolKeyFallback;
}

/** Loads `resources/schools/{schoolKey}` and returns a display name for the current app language. */
export function useSchoolDisplayName(schoolKey: string): string {
    const [lang] = useContext(langContext);
    const snap = useDatabase(`${SCHOOLS_PATH}/${schoolKey}`);
    const school = snap?.val() as Schools | undefined;
    return getSchoolDisplayName(school, schoolKey, lang);
}
